import Block from '../../../../_base/src/components/block/index'

import gsap from 'gsap'

export default class NewsItem extends Block {
	static title = 'news-item'

	// one follower is shared by every item in a list, so its cursor tracking and
	// slide direction live per follower element instead of per item
	static followers = new WeakMap()

	constructor($el) {
		super($el)

		this.offset = 100
		this.duration = 0.5
		this.ease = 'power2.inOut'

		this.$list = this.$el.closest('.news-items')

		if (!this.$list.length) {
			return
		}

		this.$follower = this.$list.findElement('follower')
		this.$inner = this.$list.findElement('follower-inner')
		this.$visual = this.$el.findElement('image')

		if (!this.$follower.length || !this.$inner.length) {
			return
		}

		// cursor effect only, so skip touch devices, mobile and reduced motion
		if (
			!window.matchMedia(
				'(hover: hover) and (min-width: 1024px) and (prefers-reduced-motion: no-preference)',
			).matches
		) {
			return
		}

		this.index = this.$list.find('.news-item').index(this.$el)
		this.state = this.getState()

		this.$el
			.on('mouseenter', () => this.showVisual())
			.on('mouseleave', () => this.removeVisuals(-this.offset))
	}

	getState() {
		const follower = this.$follower.get(0)

		if (!NewsItem.followers.has(follower)) {
			gsap.set(follower, { xPercent: -50, yPercent: -50 })

			const state = {
				prevIndex: null,
				firstEntry: true,
				xTo: gsap.quickTo(follower, 'x', { duration: 0.6, ease: 'power3' }),
				yTo: gsap.quickTo(follower, 'y', { duration: 0.6, ease: 'power3' }),
			}

			NewsItem.followers.set(follower, state)

			$(window).on('mousemove', (event) => {
				state.xTo(event.clientX)
				state.yTo(event.clientY)
			})

			this.$list.on('mouseleave', () => this.reset())
		}

		return NewsItem.followers.get(follower)
	}

	showVisual() {
		const forward =
			this.state.prevIndex === null || this.index > this.state.prevIndex

		this.state.prevIndex = this.index
		this.removeVisuals(forward ? -this.offset : this.offset)

		// an article without an image simply shows nothing
		if (!this.$visual.length) {
			this.$follower.removeModifier('active')

			return
		}

		const $clone = this.$visual.clone()

		this.$follower.addModifier('active')
		this.$inner.append($clone)

		if (this.state.firstEntry) {
			this.state.firstEntry = false

			return
		}

		gsap.fromTo(
			$clone.get(0),
			{ yPercent: forward ? this.offset : -this.offset },
			{
				yPercent: 0,
				duration: this.duration,
				ease: this.ease,
				overwrite: 'auto',
			},
		)
	}

	removeVisuals(yPercent) {
		this.$inner.children().each((index, visual) => {
			gsap.killTweensOf(visual)
			gsap.to(visual, {
				yPercent,
				duration: this.duration,
				ease: this.ease,
				overwrite: 'auto',
				onComplete: () => visual.remove(),
			})
		})
	}

	reset() {
		this.$follower.removeModifier('active')
		this.removeVisuals(-this.offset)

		this.state.firstEntry = true
		this.state.prevIndex = null
	}
}
